import { jsonMember, TypedJSON } from "typedjson";
import {
  Transaction,
  TransactionWithScriptGroups,
} from "./nervosTransactionTypes";

export function jsonCKBTxMember(): PropertyDecorator {
  const typedJson = new TypedJSON(TransactionWithScriptGroups);

  return jsonMember({
    serializer: (val: TransactionWithScriptGroups) => {
      return typedJson.toPlainJson(val);
    },
    deserializer: (val: any): TransactionWithScriptGroups => {
      return typedJson.parse(val)!;
    },
  });
}

export function jsonTxResponseMember(): PropertyDecorator {
  return jsonMember({});
}

export function jsonCKBTxViewMember(): PropertyDecorator {
  const typedJson = new TypedJSON(Transaction);

  return jsonMember({
    serializer: (val: Transaction) => {
      const plain = typedJson.toPlainJson(val);
      return ensure0xPrefixesDeep(plain); // this adds "0x" where needed
    },
    deserializer: (val: any): Transaction => {
      return typedJson.parse(val)!;
    },
  });
}

function isHexLikeField(key: string): boolean {
  return (
    key.endsWith("_hash") ||
    key === "since" ||
    key === "capacity" ||
    key === "nonce" ||
    key === "value" ||
    key === "version" ||
    key === "r" ||
    key === "s" ||
    key === "v" ||
    key === "index"
  );
}

export function ensure0xPrefixesDeep(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(ensure0xPrefixesDeep);
  }

  if (obj && typeof obj === "object") {
    for (const [key, val] of Object.entries(obj)) {
      if (typeof val === "string" && isHexLikeField(key)) {
        obj[key] = val.startsWith("0x") ? val : `0x${val}`;
      } else {
        obj[key] = ensure0xPrefixesDeep(val);
      }
    }
  }

  return obj;
}
